<template>
  <div class="doubt">
    <div class="list" v-for="item in question" :key="item.id" @click="goDetail(item.id)"><span>{{item.text}}</span></div>
  </div>
</template>

<script>
import { guideline_doubt_get } from '@/api/staticApi.js'

export default {
  data() {
    return {
      question: []
    };
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData () {
      guideline_doubt_get().then(res => {
        this.question = res
      })
    },
    goDetail (id) {
      this.$router.push({
        path: 'guide',
        query: {
          id
        }
      })
    }
  },
};
</script>

<style scoped>
.doubt{
  min-height: 100vh;
  background: #FCFBFB;
  padding: 36px 20px 0;
}
.list{
  width: 324px;
  padding: 16px;
  padding-right: 0;
  /* background: url('/images/guideline/rectangular_bg_s.png') no-repeat; */
  /* background-size: 100% 100%; */
  font-size:14px;
  color: #244352;
  box-shadow:0px 4px 6px rgba(0,0,0,0.08);
  box-sizing: border-box;
  margin-bottom: 20px;
  position: relative;
  border-radius:0px 16px 16px 16px;
  background: #fff;
}
.list:nth-last-child(1){
  margin-bottom: 0;
}
.list::after{
  content: '';
  width: 7px;
  height: 12px;
  background: url('/images/guideline/arrow.png') no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: 35px;
  top: 50%;
  transform: translateY(-50%);
}
.list>span{
  display: inline-block;
  width: 247px;
  height: 18px;
  line-height: 18px;
}
.list:nth-last-child(1)>span{
  width: 241px;
}
</style>
